// Confirmation handler for anything with class="confirm" -- looks for the data-confirm attribute for what to ask.
(function () {
    function getConfirmationMessage(el) {
        // Allow putting the message on the button itself OR on a parent element (e.g., the <form>)
        return (
            el.getAttribute("data-confirm") ||
            (el.closest("[data-confirm]") && el.closest("[data-confirm]").getAttribute("data-confirm")) ||
            "Are you sure?"
        );
    }

    document.addEventListener(
        "click",
        function (e) {
            // Works for <button>, <a>, icons inside them, etc.
            const trigger = e.target.closest(".confirm");
            if (!trigger) {
                return;
            }

            const message = getConfirmationMessage(trigger);
            const ok = window.confirm(message);

            if (!ok) {
                e.preventDefault();
                e.stopPropagation();
            }
        },
        true // capture helps stop form submits early
    );
})();

// Print handler for anything with class="print"
(function () {
    document.addEventListener(
        "click",
        function (e) {
            const trigger = e.target.closest(".print");
            if (!trigger) {
                return;
            }

            e.preventDefault();
            e.stopPropagation();
            window.print();
        },
        true
    );
})();